module.exports = __webpack_public_path__ + "media/main_melody.5d74c12f.mp3";